function toast(msg) {
  let t = document.querySelector(".toast");
  if (!t) {
    t = document.createElement("div");
    t.className = "toast";
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.add("on");
  setTimeout(() => t.classList.remove("on"), 1800);
}

function openCart(on) {
  document.querySelector("[data-cart-drawer]")?.classList.toggle("on", on);
  document.querySelector(".overlay")?.classList.toggle("on", on);
}

function money(cents) {
  return `${(cents / 100).toLocaleString("ar-EG")} ج.م`;
}

function renderCartDrawer(cart) {
  const list = document.querySelector("[data-cart-list]");
  const total = document.querySelector("[data-cart-total]");
  const badges = document.querySelectorAll("[data-cart-count]");

  badges.forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count ? "grid" : "none";
  });
  if (total) total.textContent = money(cart.total_price);

  if (!list) return;
  if (!cart.item_count) {
    list.innerHTML = `<p class="muted" style="padding:24px 0">سلتك فاضية. المجموعة بانتظارك.</p>`;
    return;
  }
  list.innerHTML = cart.items.map((item, i) => `
    <div class="cart-item" data-cart-line="${i + 1}">
      <img src="${item.image}" alt="${item.title}">
      <div>
        <strong>${item.product_title}</strong>
        <div class="muted">${item.variant_title || ""} · ${item.quantity} قطعة</div>
        <button type="button" class="icon-btn" style="width:auto;height:auto;padding:4px 0" data-cart-remove="${i + 1}">حذف</button>
      </div>
      <div>${money(item.final_line_price)}</div>
    </div>
  `).join("");
}

async function refreshCart() {
  const res = await fetch("/cart.js");
  const cart = await res.json();
  renderCartDrawer(cart);
  return cart;
}

async function addToCart(id, quantity) {
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id, quantity }] })
    });
    if (!res.ok) {
      const err = await res.json();
      toast(err.description || "القطعة دي مش متوفرة حاليًا");
      return;
    }
    await refreshCart();
    toast("أُضيف إلى السلة");
    openCart(true);
  } catch (e) {
    toast("حصل خطأ، جرّبي تاني");
  }
}

async function removeCartLine(line) {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line, quantity: 0 })
  });
  await refreshCart();
}

function mountShell() {
  document.querySelector("[data-burger]")?.addEventListener("click", () => {
    document.querySelector("[data-menu]")?.classList.toggle("open");
  });
  document.querySelector("[data-cart-open]")?.addEventListener("click", () => openCart(true));
  document.querySelectorAll("[data-cart-close]").forEach(el => el.addEventListener("click", () => openCart(false)));

  document.addEventListener("click", e => {
    const removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) removeCartLine(Number(removeBtn.dataset.cartRemove));
  });

  document.querySelector("form[action='/contact#newsletter']")?.addEventListener("submit", e => {
    // let Shopify handle the actual submit; just give feedback on next load
  });
}

function mountProduct() {
  const root = document.querySelector("[data-pdp]");
  if (!root) return;
  const variantsEl = document.getElementById("pdp-variants");
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const form = root.querySelector("[data-product-form]");
  const variantInput = root.querySelector("[data-variant-id]");
  const priceEl = root.querySelector("[data-pdp-price]");
  const imageEl = root.querySelector("[data-pdp-image]");
  const addBtn = root.querySelector("[data-add]");
  const qtyEl = root.querySelector("[data-qty]");
  let qty = 1;

  const selected = {};
  root.querySelectorAll("[data-option-index]").forEach(group => {
    const on = group.querySelector(".size.on");
    if (on) selected[group.dataset.optionIndex] = on.dataset.optionValue;
  });

  function findVariant() {
    return variants.find(v => {
      const opts = [v.option1, v.option2, v.option3];
      return Object.keys(selected).every(idx => opts[idx] === selected[idx]);
    });
  }

  function applyVariant() {
    const v = findVariant();
    if (!v) return;
    if (variantInput) variantInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (imageEl && v.featured_image) imageEl.src = v.featured_image.src;
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? "أضيفي إلى السلة" : "غير متوفرة حاليًا";
    }
  }

  root.querySelectorAll("[data-option-index]").forEach(group => {
    group.querySelectorAll(".size").forEach(btn => {
      btn.addEventListener("click", () => {
        group.querySelectorAll(".size").forEach(b => b.classList.toggle("on", b === btn));
        selected[group.dataset.optionIndex] = btn.dataset.optionValue;
        applyVariant();
      });
    });
  });

  root.querySelectorAll("[data-q]").forEach(btn => {
    btn.addEventListener("click", () => {
      qty = Math.max(1, qty + (btn.dataset.q === "+" ? 1 : -1));
      if (qtyEl) qtyEl.textContent = qty;
    });
  });

  form?.addEventListener("submit", e => {
    e.preventDefault();
    if (variantInput?.value) addToCart(Number(variantInput.value), qty);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  mountShell();
  mountProduct();
});
